.container {
  display: flex;
  flex-direction: column;
  flex: 1;
  max-width: 100%;
}
